function toSx(styles, classes) {
  return function sxCallback(theme) {
    let sx = {}
    Object.entries(styles(theme)).forEach(([key, value]) => {
      if (key === 'root') {
        sx = { ...sx, ...value }
      } else {
        sx[`& .${classes[key]}`] = value
      }
    })
    return sx
  }
}

export { toSx }
